import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter, forwardRef,
  inject,
  Input, OnInit, Optional,
  Output,
  ViewChild
} from '@angular/core';
import { ControlContainer, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, NgControl } from "@angular/forms";
import { Observable } from "rxjs";
import { PlacesService } from '../../../../../common/src/lib/services/places.service';
import { AddressComponents, addressComponentsEmpty } from "../../../../../common/src/lib/models/address-comments.model";
import { componentsToString } from "../../../../../common/src/lib/pipes/address.pipe";

@Component({
  selector: 'address-form-field',
  templateUrl: './address-form-field.component.html',
  styleUrls: ['./address-form-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AddressFormFieldComponent),
      multi: true,
    },
  ],
})
export class AddressFormFieldComponent extends FormControl implements ControlValueAccessor, AfterViewInit, OnInit {

  private placesService = inject(PlacesService);
  @Optional() private controlContainer = inject(ControlContainer);

  @ViewChild('addressInput') addressInput!: ElementRef<HTMLInputElement>;
  @ViewChild('addressInput', {read: NgControl})
  addressInputDirective!: NgControl;

  @Input() placeholder: string = '';
  @Input() formControl!: FormControl;
  @Input() formControlName!: string;
  @Input() error?: string;

  @Output() onFocus = new EventEmitter<boolean>();
  @Output() onClick = new EventEmitter<boolean>();

  value: string = '';
  onChange = (value: AddressComponents) => {};
  onTouched = () => {};

  addressPredictions$?: Observable<google.maps.places.AutocompletePrediction[] | null>;

  ngOnInit() {
      if (!this.formControl && this.formControlName && this.controlContainer) {
          this.formControl = this.controlContainer.control?.get(this.formControlName) as FormControl;
      }
  }

  async ngAfterViewInit() {
    this.addressPredictions$ = await this.placesService.getPlaceAutocomplete(this.addressInput, 'address');
    if(this.formControl.value) {
      this.onPlacesOptionSelected(this.formControl.value);
    }
  }

  onPlacesOptionSelected(place: AddressComponents) {
    this.addressInputDirective.valueAccessor?.writeValue(componentsToString(place as any));
    const addressControl = this.formControl;
    addressControl.setValue(place, { emitModelToViewChange: false });

    if(addressComponentsEmpty(place)) {
      addressControl.setErrors({ missingComponents: true });
      addressControl.markAsTouched();
    } else {
      addressControl.setErrors(null);
    }
  }

  click() {
    if(this.onClick.observers.length > 0)
      this.onClick.emit();
    else
      this.addressInput.nativeElement.blur();
  }

  writeValue(value: string): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optional: Handle disabled state if needed
  }

}
